import { Box, Flex } from "@chakra-ui/react";
import { memo } from "react";
import { useRecoilState } from "recoil";

import { OFModal } from "design_system/components/Modal";
import { OFText } from "design_system/components/OFText";
import { colors } from "src/colors";
import { isWarningRenewModalOpenedState } from "src/states";

interface Props {
  t: (key: string) => string;
}

const WarningReNewModal = ({ t }: Props) => {
  const [isWarningRenewModalOpened, setIsWarningRenewModalOpened] = useRecoilState(
    isWarningRenewModalOpenedState
  );

  return (
    <OFModal
      onClose={() => {
        setIsWarningRenewModalOpened(false);
      }}
      isOpen={isWarningRenewModalOpened}
    >
      <Flex justifyContent="center" flexDirection="column">
        <OFText textStyle="h4" borderBottom={`1px solid ${colors.grey[500]}`}>
          {t("checkout:warning-modal-renew.title")}
        </OFText>

        <Box whiteSpace="pre-line" fontSize={{ base: "md" }} textAlign="left">
          <OFText textStyle="body1" mt="24px" mb="5px">
            {t("checkout:warning-modal-renew.p1")}
          </OFText>
          <OFText textStyle="body1">{t("checkout:warning-modal-renew.p2")}</OFText>
        </Box>
      </Flex>
    </OFModal>
  );
};

export default memo(WarningReNewModal);
